<template>
  <!-- 应收计费列表 -->
  <div class="container">
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="应收费项列表" name="first">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="addBtn"
              >新增</el-button
            >
            <el-button class="glo_btnItems glo_bgcMainColor" @click="updateBtn"
              >修改</el-button>
            <el-button class="glo_btnItems glo_bgcMainColor" @click="onCaiwuQdSp()"
              >审核</el-button>
            <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onCaiwuQxSp()"
            >反审核</el-button
            >
            <el-button plain class="glo_btnItems glo_bgcMainColor" @click="delGoods()"
            >删除</el-button
            >
            <el-button plain class="jy-button" @click="onCreateWaybillServiceBill()"
            >生成运费单</el-button
            >
            <el-button class="jy-button " @click="myModel"
            >表格设置</el-button
            >
            <template >
              <div class="tableExportBtn">
                <exportTb
                    :theadData="myTableHeard"
                    :tableData="tableData"
                    :resultData="tableData"
                    @handleExportDia_dc="handleExportDia_dc('应收费项列表')"
                ></exportTb>
              </div>
            </template>
          </div>
          <queryBtns
            :MoreConditions="MoreConditions"
            @clerBtns="clerBtns"
            @queryBtn_ok="queryBtn_ok"
            @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <!-- :formData="queryData" -->
        <queryCondition
          ref="queryForm"
          :More="isHaseMore"
          :formConfig="queryCondditionDatas"
        ></queryCondition>


        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
            :height="tableHeigth"
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            border
            stripe
            :highlight-current-row="true"
            show-summary
            :summary-method="getSummaries"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                v-if="item.field === 'aaaaaaaaaa' && item.isShow"
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="left"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel">
                    {{ scope.row.aaaaaaaaaa }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>

        <!-- 分页 -->
        <paging
          ref="pags"
          :pageNum="pageStart"
          :total="pageCount"
          :size="pageTotal"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </el-tab-pane>
      <el-tab-pane label="运费单列表" name="second">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="onUpdateWaybillServiceBill()"
            >修改</el-button>
            <el-button class="glo_btnItems glo_bgcMainColor" @click="onExamWaybillFeeBillV4()"
            >审核</el-button>
            <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onCancelExamWaybillFeeBillV4()"
            >反审核</el-button
            >
            <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onWriteOffWaybillFeeBillV4()"
            >核销</el-button
            >
            <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onFinanceRecordGroupPartWriteOff()"
            >部分核销</el-button
            >
            <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onMemberAccountWriteOffWaybillFeeBillV4()"
            >余额核销</el-button
            >
            <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onGetWaybillFeeBillWriteoffRecorList()"
            >核销记录</el-button
            >
            <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onDelWaybillFeeBillV4()"
            >删除</el-button
            >
            <el-button plain class="glo_btnItems glo_bgcMainColor" @click="onCreateStatement()"
            >生成对账单</el-button
            >
            <el-button class="jy-button " @click="myModel"
            >表格设置</el-button
            >
            <template >
              <div class="tableExportBtn">
                <exportTb
                    :theadData="myTableHeard"
                    :tableData="tableData"
                    :resultData="tableData"
                    @handleExportDia_dc="handleExportDia_dc('运费单列表')"
                ></exportTb>
              </div>
            </template>
          </div>
          <queryBtns
              :MoreConditions="MoreConditions"
              @clerBtns="clerBtns"
              @queryBtn_ok="queryBtn_ok"
              @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <!-- :formData="queryData" -->
        <queryCondition
            ref="queryForm"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
        ></queryCondition>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
              :height="tableHeigth"
              header-align="center"
              ref="mytable"
              @row-click="rowclick"
              :data="tableData"
              border
              stripe
              :highlight-current-row="true"
              show-summary
              :summary-method="getSummaries"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
            ></el-table-column>
            <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                  v-if="item.field === 'aaaaaaaaaa' && item.isShow"
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="left"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel">
                    {{ scope.row.aaaaaaaaaa }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>

        <!-- 分页 -->
        <paging
            ref="pags"
            :pageNum="pageStart"
            :total="pageCount"
            :size="pageTotal"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
        ></paging>


      </el-tab-pane>
    </el-tabs>
    <!--        自定义表头           -->
    <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
    ></sorttable>

    <!-- 导出插件 -->
    <exportComponent
        :isShowDialog_dc="exportForm.isShowDialog_dc"
        :diaWidth_dc="exportForm.diaWidth_dc"
        :diaHeight_dc="exportForm.diaHeight_dc"
        :dialogTitle="exportForm.dialogTitle"
        :dialogForm_dc="exportForm.dialogForm_dc"
        :data="exportForm.queryForm"
        :tableHeard="exportForm.EPtableHeard"
        :AllCheck="exportForm.EPAllCheck"
        @checktabEP="checktabEP"
        @checkAllEP="checkAllEP"
        @onAfterEnter="onAfterEnter"
        @handleCloseDia_dc="handleCloseDia_dc"
        @diaConfirmBtn_dc="diaConfirmBtn_dc"
        queryType="exportModeList"
    >
    </exportComponent>


    <!-- 收款确认 -->
    <div>
      <el-dialog
          title="收款确认"
          :visible.sync="show_writeOff"
          :modal-append-to-body="false"
          width="40%"
          center
          @close="closeDiawriteOff"
      >
        <div>
          <el-form
              label-position="right"
              label-width="80px"
              :model="formLabelAlign"
          >
            <el-form-item label="收款金额">
              <el-input
                  readonly
                  v-model="formLabelAlign.amountCollected"
              ></el-input>
            </el-form-item>
            <el-form-item label="资金账户">
              <el-select
                  v-model="formLabelAlign.accountId"
                  filterable
                  clearable
                  placeholder="请选择账户类型"
                  @change="changeAccountId"
              >
                <el-option
                    v-for="(item, idx) in capitalAccountList"
                    :key="idx"
                    :label="item.showTitle"
                    :value="item.accountId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="核销时间">
              <el-date-picker
                  style="width: 100%"
                  class="input"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="formLabelAlign.writeOffTime"
                  type="datetime"
                  placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="上传图片">
              <uploadimgs
                  @input="dialogChangeFileList"
                  :fileNameLists="dialogFileNameLists"
                  :limit="99"
                  listType="picture-card"
              ></uploadimgs>
            </el-form-item>
            <!-- <el-form-item label="账户类型">
              <el-select
                v-model="formLabelAlign.accountStatus"
                placeholder="请选择账户类型"
              >
                <el-option
                  v-for="(item, idx) in account_status_list"
                  :key="idx"
                  :label="item.showName"
                  :value="item.statusVal"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="资金账户">
              <el-input v-model="formLabelAlign.accountId"></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="saveBtn" @click="saveWriteOff">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 部分收款确认 -->
    <div>
      <el-dialog
          title="部分收款确认"
          :visible.sync="show_partWriteOff"
          :modal-append-to-body="false"
          width="40%"
          center
          @close="closeDiaPartWriteOff"
      >
        <div>
          <el-form
              label-position="right"
              label-width="80px"
              :model="formLabelAlign"
          >
            <el-form-item label="收款金额">
              <el-input
                  v-model="formLabelAlign.amountCollected"
              ></el-input>
            </el-form-item>
            <el-form-item label="资金账户">
              <el-select
                  v-model="formLabelAlign.accountId"
                  filterable
                  clearable
                  placeholder="请选择账户类型"
                  @change="changeAccountId"
              >
                <el-option
                    v-for="(item, idx) in capitalAccountList"
                    :key="idx"
                    :label="item.showTitle"
                    :value="item.accountId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="核销时间">
              <el-date-picker
                  style="width: 100%"
                  class="input"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="formLabelAlign.writeOffTime"
                  type="datetime"
                  placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="上传图片">
              <uploadimgs
                  @input="dialogChangeFileList"
                  :fileNameLists="dialogFileNameLists"
                  :limit="99"
                  listType="picture-card"
              ></uploadimgs>
            </el-form-item>
            <!-- <el-form-item label="账户类型">
              <el-select
                v-model="formLabelAlign.accountStatus"
                placeholder="请选择账户类型"
              >
                <el-option
                  v-for="(item, idx) in account_status_list"
                  :key="idx"
                  :label="item.showName"
                  :value="item.statusVal"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="资金账户">
              <el-input v-model="formLabelAlign.accountId"></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="saveBtn" @click="savePartWriteOff">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 会员余额核销 -->
    <div>
      <el-dialog
          title="会员余额核销确认"
          :visible.sync="show_writeOff_ye"
          :modal-append-to-body="false"
          width="40%"
          center
          @close="closeDiawriteOff_ye"
      >
        <div>
          <el-form
              label-position="right"
              label-width="80px"
              :model="formDataYuE"
              :rules="rulesYe"
          >
            <el-form-item label="会员号:">
              <el-input readonly v-model="formDataYuE.memberNamse"></el-input>
            </el-form-item>
            <el-form-item label="会员余额">
              <el-input readonly v-model="formDataYuE.memberMoney"></el-input>
            </el-form-item>
            <el-form-item label="资金账户">
              <el-select
                  v-model="formDataYuE.accountId"
                  filterable
                  clearable
                  placeholder="请选择账户类型"
                  @change="changeYuEAccountId"
              >
                <el-option
                    v-for="(item, idx) in capitalAccountList"
                    :key="idx"
                    :label="item.showTitle"
                    :value="item.accountId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="核销金额" prop="writeOffMoney">
              <el-input v-model="formDataYuE.writeOffMoney"></el-input>
            </el-form-item>
            <el-form-item label="核销时间" prop="writeOffTime">
              <el-date-picker
                  style="width: 100%"
                  class="input"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="formDataYuE.writeOffTime"
                  type="datetime"
                  placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注" prop="comment">
              <el-input
                  teye="textarea"
                  v-model="formDataYuE.comment"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传图片">
              <uploadimgs
                  @input="dialogChangeYuEFileList"
                  :fileNameLists="dialogFileNameLists"
                  :limit="99"
                  listType="picture-card"
              ></uploadimgs>
              <!-- <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog> -->
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="saveBtn" @click="saveWriteOff_ye">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 返核销 -->
<!--    <div>-->
<!--      <el-dialog-->
<!--          title="返核销确认"-->
<!--          :visible.sync="show_writeOff_fhx"-->
<!--          :modal-append-to-body="false"-->
<!--          width="45%"-->
<!--          center-->
<!--          @close="closeDiawriteOff_fhx"-->
<!--      >-->
<!--        <div>-->
<!--          <el-form-->
<!--              label-position="right"-->
<!--              label-width="120px"-->
<!--              :model="formDataFHX"-->
<!--              :rules="rulesYe"-->
<!--          >-->
<!--            <el-form-item label="付款方式">-->
<!--              <el-select-->
<!--                  v-model="formDataFHX.paymentMethod"-->
<!--                  placeholder="请选择账户类型"-->
<!--                  @change="changeRway_fhx"-->
<!--                  filterable-->
<!--                  clearable-->
<!--              >-->
<!--                <el-option-->
<!--                    v-for="(item, idx) in payment_method_list"-->
<!--                    :key="idx"-->
<!--                    :label="item.showName"-->
<!--                    :value="item.statusVal"-->
<!--                ></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="收款总金额">-->
<!--              <el-input-->
<!--                  readonly-->
<!--                  v-model.trim="formDataFHX.memberMoney"-->
<!--              ></el-input>-->
<!--            </el-form-item>-->

<!--            &lt;!&ndash; <el-form-item label="资金账户">-->
<!--              <el-select-->
<!--                v-model="formDataFHX.accountId"-->
<!--                filterable-->
<!--                clearable-->
<!--                placeholder="请选择退款账号"-->
<!--                @change="changeAccountId_FHX"-->
<!--              >-->
<!--                <el-option-->
<!--                  v-for="(item, idx) in capitalAccountList"-->
<!--                  :key="idx"-->
<!--                  :label="item.showTitle"-->
<!--                  :value="item.accountId"-->
<!--                ></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item> &ndash;&gt;-->
<!--          </el-form>-->
<!--        </div>-->
<!--        <div slot="footer" class="dialog-footer">-->
<!--          <el-button class="saveBtn" @click="saveWriteOff_fsh"-->
<!--          >取消收款</el-button-->
<!--          >-->
<!--        </div>-->
<!--      </el-dialog>-->
<!--    </div>-->
    <!-- 核销记录 劲亚-->
    <Dialog
        :show="writeoffRecorListVisible"
        class="dialog-padding-container"
        :title="writeoffRecorListTitle"
        width="80%"
        @onCancel="writeoffRecorListCancel"
        :footer="false"
    >
      <el-form label-width="150px" label-position="right">
        <el-row :gutter="24">
          <el-col :span="24">
            <div class="table-ground" style="margin-top: 20px">
              <el-table
                  class="jy-common-table"
                  show-summary
                  header-align="center"
                  border
                  stripe
                  :highlight-current-row="true"
                  style="width: 100%"
                  :data="writeOffRecordTable"
              >
                <el-table-column
                    fixed="left"
                    align="center"
                    label="序号"
                    type="index"
                    width="60"
                ></el-table-column>

                <el-table-column
                    class-name="jy-required"
                    align="center"
                    prop="writeoffAmount"
                    label="核销金额"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="unweiteoffAmount"
                    label="剩余待核销金额"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="zjAccount"
                    label="核销资金账号"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="operationTypeShow"
                    label="操作类型"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="isUnwriteoffShow"
                    label="是否操作反核销"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="writeoffUserName"
                    label="核销人"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="writeoffTime"
                    label="核销时间"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="writeoffComment"
                    label="核销备注"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    label="图片"
                    fixed="right"
                    width="180"
                >
                  <template #default="scope">
                    <el-button link @click="onViewAnnexD(scope)">查看</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    fixed="right"
                    width="180"
                >
                  <template #default="scope">
                    <el-button
                        link
                        @click="onChunaReApproverApplyStatement(scope.row)"
                    >反核销</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </Dialog>
    <Dialog
        :show="writeoffRecorFJVisible"
        class="dialog-padding-container"
        :title="writeoffRecorFJTitle"
        width="80%"
        @onCancel="writeoffRecorFJCancel"
        :footer="false"
    >
      <commonFuJian
          :showBtns="showBtns"
          :data="annexTableBF"
          :disabled="!showBtns"
          ref="domCommonFuJianBF"
      ></commonFuJian>
    </Dialog>
  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
import tableListNew from "@/pages/tableListNew.js";
//   import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import customerModelService from "@/components/customerService/modelIndex.vue";
import { Api } from "@/assets/js/api";
import mathjs from "@/assets/js/MathNumBer";
import commonFuJian from "@/components/fuJian/index.vue"
import uploadimgs from "@/components/upLoadImgs.vue";
import exportTb from "@/components/exportComponent/exportTb.vue";
import exportComponent from "@/components/exportComponent/index.vue";
import sorttable from "@/components/sortTemplate.vue";
export default {
  mixins: [tableList,tableListNew],
  inject: ["reload"],
  components: {
    sorttable, exportComponent,
    exportTb,
    uploadimgs,
    //   sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    customerModelService,
    commonFuJian
  },
  data() {
    return {
      userList: [],

      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "提货指令列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "financeInItemSerivceList", //  页面标识
      reportFiledsNumber: "finance_in_item_service_list_v4", // 动态 条件、表头
      pageGroupNameMap: {
        first: "financeInItemSerivceList", //
        second: "financeInWaybillItemServiceList" //
      },
      currentItemArr: [],
      dialogType: "",
      showTimers:false,
      dataList: [],
      oneDocuNumber: "",
      customerModelServiceStatus: false,
      mxSearchHeight: 71,
      activeName: "first",
      tabCache: {
        first: {
          queryData: {},
          tableData: [],
          queryCondditionDatas: [],
          tableHeader: []  // 添加这个字段
        },
        second: {
          queryData: {},
          tableData: [],
          queryCondditionDatas: [],
          tableHeader: []  // 添加这个字段
        }
      },
      currentTab: 'first',
      ruCangData:{
        arrivalStorageId: "",
        arrivalTime: "",
        entruckId: [],
      },
      commonDocVisible: false,
      storageOptions: [],
      confirmIntoStorageVisible : false,
      show_writeOff: false, //收款确认弹窗
      show_partWriteOff: false, //部分收款确认弹窗
      show_writeOff_ye: false, //会员余额收款确认弹窗
      show_writeOff_fhx: false, //返核销确认弹窗
      formLabelAlign: {
        amountCollected: "", //收款金额
        accountStatus: "", //账户类型
        accountId: "", //资金账户id
        writeOffTime: "", //
        writeOffPic: "", //
        ids: [], //应收计费id数组
        files : [],
        writeoffComment: "",
      },
      account_status_list: [], //资金账号类型
      capitalAccountList: [], //资金账号下拉列表
      dialogFileNameLists: [],
      formDataYuE: {
        comment: "",
        ids: [],
        writeOffTime: "",
        memberNamse: "",
        memberMoney: "", //余额
        writeOffMoney: "", //核销金额
        accountId: "", //
        files : [],
      },
      rulesYe: {
        writeOffMoney: [
          { required: true, message: "请输入核销金额", trigger: "blur" },
        ],
        writeOffTime: [
          { required: true, message: "请选择核销时间", trigger: "blur" },
        ],
        accountId: [
          { required: true, message: "请选择资金账号", trigger: "change" },
        ],
        comment: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      JLshow: false,
      JLTitle: "",
      MainId: "",
      tableDataJL: [],
      theadDataJL: [
        {
          isShow: 1,

          fieldAlias: "operationTypeShow",
          fieldNameShow: "操作类型",
          isSum: 0,
        },
        {
          isShow: 1,

          fieldAlias: "settlementAmount",
          fieldNameShow: "总金额",
          isSum: 0,
        },
        {
          isShow: 1,

          fieldAlias: "writeoffedAmount",
          fieldNameShow: "已核销金额",
          isSum: 0,
        },
        {
          isShow: 1,

          fieldAlias: "writeoffAmount",
          fieldNameShow: "本次核销金额",
          isSum: 0,
        },
        {
          isShow: 1,

          fieldAlias: "unwriteoffAmount",
          fieldNameShow: "剩余待核销金额",
          isSum: 0,
        },
        {
          isShow: 1,

          fieldAlias: "zjAccount",
          fieldNameShow: "核销资金账号",
          isSum: 0,
        },
        {
          isShow: 1,

          fieldAlias: "writeoffUserName",
          fieldNameShow: "核销人",
          isSum: 0,
        },
        {
          isShow: 1,

          fieldAlias: "writeoffTime",
          fieldNameShow: "核销时间",
          isSum: 0,
        },
        {
          isShow: 1,

          fieldAlias: "writeoffComment",
          fieldNameShow: "核销备注",
          isSum: 0,
        },
        {
          isShow: 1,

          fieldAlias: "operationTime",
          fieldNameShow: "操作时间",
          isSum: 0,
        },
      ],
      writeoffRecorListVisible: false,
      writeoffRecorListTitle: "核销记录",
      writeOffRecordTable: [],
      annexTableBF: [],
      showBtns: false,
      domCommonFuJianBF:  null,
      writeoffRecorFJVisible: false,
      writeoffRecorFJTitle: "附件",

    };
  },
  mounted() {
    this.getData();
  },
  watch: {},
  methods: {

    mxSetHeight(num) {
      this.mxSearchHeight = num + 15;
    },
    handleClick(tab, event) {
      // 保存当前 tab 的状态
      if (this.activeName && this.$refs.queryForm) {
        const currentFormData = this.$refs.queryForm.getFormData ?
            this.$refs.queryForm.getFormData() :
            this.$refs.queryForm.formData;

        if (!this.tabCache) {
          this.tabCache = {
            first: {},
            second: {}
          };
        }

        // 缓存当前 tab 的数据
        this.tabCache[this.activeName] = {
          ...this.tabCache[this.activeName],
          queryData: currentFormData,
          pageStart: this.pageStart
        };
      }

      // 切换 tab
      this.activeName = tab.name;

      let rqNumber = "finance_in_item_service_list_v4";
      this.pageGroupName = this.pageGroupNameMap[tab.name];
      if (tab.name === "second") {
        this.mxSearchHeight = this.mxSearchHeight > 86 ? this.mxSearchHeight : 86;
        rqNumber = "finance_waybill_fee_list";
      }

      // 初始化目标 tab
      this.initTableByTab(tab.name, rqNumber);
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },

    addBtn(){
      this.$router.push({
        path: "/pages/v4/finance/addFIItemService",
      });
    },
    updateBtn(){
      if (!this.currentItemArr||this.currentItemArr.length!==1) {
        ElMessage({
          message: "请选择一条数据",
          type: "warning",
        });
        return;
      }
      let currentItemArrElement = this.currentItemArr[0];
      this.$router.push({
        query: {
          documentStatus: currentItemArrElement.documentStatus,
          documentNumber: currentItemArrElement.documentNumber,
        },
        path: "/pages/v4/finance/modifyFIItemService",
      });
    },
    async onCaiwuQdSp(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.id];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择审核费项",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.id;
        });
      }

      let obj = {
        billItemServiceTableIds: ids,
      };
      await Api.examFinanceInService(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
            if("success"===data.status){
              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            }
          }
        }
      });
    },
    async onCaiwuQxSp(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.id];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择反审核的费项",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.id;
        });
      }

      let obj = {
        billItemServiceTableIds: ids,
      };
      await Api.cancelExamFinanceInService(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
            if("success"===data.status){
              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            }
          }
        }
      });
    },
    async delGoods(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.id];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择删除的费项",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.id;
        });
      }

      let obj = {
        billItemServiceTableIds: ids,
      };
      await Api.delFinanceInService(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
            if("success"===data.status){
              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            }
          }
        }
      });
    },

    async onCreateWaybillServiceBill(){
      if (this.currentItemArr.length >= 1) {
        ElMessageBox.confirm("确认所选数据生成应收运费单？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          for (let key in this.currentItemArr) {
            let ele = this.currentItemArr[key];
            if (!ele.currency) {
              ElMessage({
                message: "请设置币种！",
                type: "error",
              });
              return false;
            }

            if (!ele.financeId) {
              ElMessage({
                message: "所选运单费项应收暂未审核通过,请先审核！",
                type: "error",
              });
              return false;
            }
          }
          const idList = this.currentItemArr.map((item) => {
            return item.financeId;
          });
          let params = {
            financeInIds: idList,
          };
          await Api.createWaybillFeeBill(params).then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (utils.jyCheckObjectType(data) === "Object") {
                ElMessage({
                  message: data.message,
                  type: data.status,
                });
              }
            }
          });
        });
      } else {
        ElMessage({
          message: "请选择表格数据",
          type: "warning",
        });
      }
    },


    async onUpdateWaybillServiceBill(){
      if (!this.currentItemArr||this.currentItemArr.length!==1) {
        ElMessage({
          message: "请选择一条数据",
          type: "warning",
        });
        return;
      }
      let currentItemArrElement = this.currentItemArr[0];
      this.$router.push({
        query: {
          financeId: currentItemArrElement.financeId,
        },
        path: "/pages/v4/finance/modifyFinanceInWaybillServiceBill",
      });

    },

    async onExamWaybillFeeBillV4(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.financeId];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择审核单据",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.financeId;
        });
      }

      let obj = {
        financeIds: ids,
      };
      await Api.examWaybillFeeBillV4(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
            if("success"===data.status){
              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            }
          }
        }
      });
    },

    async onCancelExamWaybillFeeBillV4(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.financeId];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择反审核单据",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.financeId;
        });
      }

      let obj = {
        financeIds: ids,
      };
      await Api.cancelExamWaybillFeeBillV4(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
            if("success"===data.status){
              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            }
          }
        }
      });
    },

    onWriteOffWaybillFeeBillV4(){
      let arr = this.currentItemArr || [];
      if (arr.length < 1) {
        this.$message.warning("至少选择一条数据");
        return;
      }
      var idList = [];
      var count = 0;
      for (var i = 0; i < arr.length; i++) {
        idList.push(arr[i].financeId);
        count = mathjs.add(count, arr[i].unwriteoffAmount); //精度计算
      }
      this.getCapitalAccountList(); //获取资金账户下拉列表
      this.formLabelAlign.ids = idList;
      this.formLabelAlign.amountCollected = count;
      this.show_writeOff = true;
      this.dialogFileNameLists = [];
    },

    onFinanceRecordGroupPartWriteOff(){
      let arr = this.currentItemArr || [];
      if (arr.length !== 1) {
        this.$message.warning("请选择一条数据");
        return;
      }
      var idList = [];
      var count = 0;
      for (var i = 0; i < arr.length; i++) {
        idList.push(arr[i].financeId);
        count = mathjs.add(count, arr[i].unwriteoffAmount); //精度计算
      }
      this.getCapitalAccountList(); //获取资金账户下拉列表
      this.formLabelAlign.ids = idList;
      this.formLabelAlign.amountCollected = count;
      this.show_partWriteOff = true;
      this.dialogFileNameLists = [];
    },

    onMemberAccountWriteOffWaybillFeeBillV4(){
      let arr = this.currentItemArr || [];
      if (arr.length < 1) {
        this.$message.warning("至少选择一条数据");
        return;
      }
      var idList = [];
      var count = 0; //核销金额
      var count2 = 0; //会员余额
      console.log(arr);
      console.log("arr");
      let memberId = arr[0].memberId;
      for (var i = 0; i < arr.length; i++) {
        if (memberId !== arr[i].memberId) {
          this.$message.warning("所选应付单存在多个会员,不能核销");
          return false;
        }
        idList.push(arr[i].financeId);
        count = mathjs.add(count, arr[i].unwriteoffAmount); //精度计算 核销金额
        count2 = mathjs.add(count2, arr[i].curAmount); //精度计算  会员余额
      }
      this.formDataYuE.memberNamse = arr[0].memberId + " " + arr[0].userMemberName;
      this.formDataYuE.writeOffMoney = count || 0;
      // this.formDataYuE.memberMoney = count2 || 0;//取消余额累加
      this.formDataYuE.memberMoney = JSON.parse(
          JSON.stringify(arr[0].curAmount)
      );
      this.formDataYuE.ids = idList;
      this.show_writeOff_ye = true;
      this.getCapitalAccountList(); //获取资金账户下拉列表
    },

    async onDelWaybillFeeBillV4(row){
      let ids = [];
      if (row) {
        const rowData = row.row;
        console.log("rowData", rowData);
        ids = [rowData.financeId];
      } else {
        if (this.currentItemArr.length < 1) {
          ElMessage({
            message: "请选择需要删除的单据",
            type: "warning",
          });
          return false;
        }
        ids = this.currentItemArr.map((item) => {
          return item.financeId;
        });
      }

      let obj = {
        financeIds: ids,
      };
      await Api.delWaybillFeeBillV4(obj).then((res) => {
        if (res.status === 200) {
          const data = res.data;
          if (utils.jyCheckObjectType(data) === "Object") {
            ElMessage({
              message: data.message,
              type: data.status,
            });
            if("success"===data.status){
              let that = this;
              setTimeout(() => {
                that.queryBtn_ok();
              }, 500);
            }
          }
        }
      });
    },
    //确认收款弹窗关闭
    closeDiawriteOff() {
      this.formLabelAlign = {
        amountCollected: "", //收款金额
        accountStatus: "", //账户类型
        accountId: "", //资金账户id
        ids: [], //应收计费id数组
        writeOffTime: "", //
        writeOffPic: "", //
      };
      this.fileListImg = [];
      this.AllwriteOffPic = [];
    },
    //部分确认收款弹窗关闭
    closeDiaPartWriteOff() {
      this.formLabelAlign = {
        amountCollected: "", //收款金额
        accountStatus: "", //账户类型
        accountId: "", //资金账户id
        ids: [], //应收计费id数组
        writeOffTime: "", //
        writeOffPic: "", //
      };
      this.fileListImg = [];
      this.AllwriteOffPic = [];
    },
    //确认收款弹窗关闭
    closeDiawriteOff_ye() {
      this.formDataYuE = {
        comment: "",
        ids: [],
        writeOffPic: "",
        writeOffTime: "",
        memberNamse: "",
        memberMoney: "",
        writeOffMoney: "",
        accountId: "",
      };
      this.fileListImg_ye = [];
      this.AllwriteOffPic = [];
    },
    //确认收款弹窗关闭
    closeDiawriteOff_fhx() {
      this.formDataFHX = {};
      this.fileListImg_ye = [];
      this.AllwriteOffPic = [];
    },

    //资金账户下拉列表
    getCapitalAccountList() {
      Api.capitalAccountList().then((res) => {
        if (res.data.status == "success") {
          let capitalAccountList = res.data.result || [];
          for (var i = 0; i < capitalAccountList.length; i++) {
            capitalAccountList[i].showTitle =
                capitalAccountList[i].accountName +
                " " +
                capitalAccountList[i].account +
                " ";
            for (var j = 0; j < this.account_status_list.length; j++) {
              if (
                  capitalAccountList[i].accountStatus ==
                  this.account_status_list[j].statusVal
              ) {
                let staVal = this.account_status_list[j].showName;
                capitalAccountList[i].showTitle += staVal;
              }
            }
          }
          this.capitalAccountList = capitalAccountList;
        }
      });
    },
    //选择资金账户
    changeAccountId(e) {
      ////console.log(e);
      let id = e;
      let arrs = this.capitalAccountList || [];
      for (var i = 0; i < arrs.length; i++) {
        if (arrs[i].accountId == id) {
          this.formLabelAlign.accountStatus = arrs[i].accountStatus;
        }
      }
    },
    changeYuEAccountId(e) {
      ////console.log(e);
      let id = e;
      let arrs = this.capitalAccountList || [];
      for (var i = 0; i < arrs.length; i++) {
        if (arrs[i].accountId == id) {
          this.formDataYuE.accountStatus = arrs[i].accountStatus;
        }
      }
    },

    dialogChangeFileList(array){
      if (utils.jyCheckObjectType(array) === "Array") {
        let flists = [];
        let listA = JSON.parse(JSON.stringify(array));

        listA.forEach((item) => {
          if (item.status === "ready") {
          } else {
            flists.push(item);
          }
        });
        this.formLabelAlign.files = flists;
        this.dialogFileNameLists = flists;
      }
    },
    dialogChangeYuEFileList(array){
      if (utils.jyCheckObjectType(array) === "Array") {
        let flists = [];
        let listA = JSON.parse(JSON.stringify(array));

        listA.forEach((item) => {
          if (item.status === "ready") {
          } else {
            flists.push(item);
          }
        });
        this.formLabelAlign.files = flists;
        this.dialogFileNameLists = flists;
      }
    },

    saveWriteOff_ye(){
      let files = this.formDataYuE.files;
      if(files){
        files.forEach((item) => {
          item.fileId = item.name;
          item.fileName = item.name;
          item.operationType = "ADD";
        });
      }

      let param = {
        accountStatus: this.formDataYuE.accountStatus, //账户类型
        accountId: this.formDataYuE.accountId, //资金账户id
        writeOffTime: this.formDataYuE.writeOffTime, //
        writeOffPics: files || [], //
        financeIds: this.formDataYuE.ids || [], //应收计费id数组
        writeoffComment: this.formDataYuE.comment,
      };
      Api.memberAccountWriteOffWaybillFeeBillV4(param).then((res) => {
        if (res.data.status == "success") {
          this.$message.success(res.data.message || "操作成功");
          this.show_writeOff = false;
          this.getData();
        }
      });
    },
    //确定核销
    saveWriteOff() {
      // let param = this.formLabelAlign;
      // param.ids = param.ids;
      ////console.log(param);
      let files = this.formLabelAlign.files;
      if(files){
        files.forEach((item) => {
          item.fileId = item.name;
          item.fileName = item.name;
          item.operationType = "ADD";
        });
      }

      let param = {
        amountCollected: this.formLabelAlign.amountCollected, //收款金额
        accountStatus: this.formLabelAlign.accountStatus, //账户类型
        accountId: this.formLabelAlign.accountId, //资金账户id
        writeOffTime: this.formLabelAlign.writeOffTime, //
        writeOffPics: files || [], //
        financeIds: this.formLabelAlign.ids || [], //应收计费id数组
        writeoffComment: this.formLabelAlign.writeoffComment,
      };
      Api.writeOffWaybillFeeBillV4(param).then((res) => {
        if (res.data.status == "success") {
          this.$message.success(res.data.message || "操作成功");
          this.show_writeOff = false;
          this.getData();
        }
      });
    },

    //确定部分核销
    savePartWriteOff() {
      // let param = this.formLabelAlign;
      // param.ids = param.ids;
      ////console.log(param);
      let files = this.formLabelAlign.files;
      if(files){
        files.forEach((item) => {
          item.fileId = item.name;
          item.fileName = item.name;
          item.operationType = "ADD";
        });
      }

      let param = {
        writeoffAmount: this.formLabelAlign.amountCollected, //收款金额
        accountStatus: this.formLabelAlign.accountStatus, //账户类型
        accountId: this.formLabelAlign.accountId, //资金账户id
        writeOffTime: this.formLabelAlign.writeOffTime, //
        writeOffPics: files || [], //
        financeId: this.formLabelAlign.ids[0], //应收计费id数组
        writeoffComment: this.formLabelAlign.writeoffComment,
      };
      Api.financeRecordGroupPartWriteOff(param).then((res) => {
        if (res.data.status == "success") {
          this.$message.success(res.data.message || "操作成功");
          this.show_partWriteOff = false;
          this.getData();
        }
      });
    },

    saveWriteOff_fsh(){

    },

    JLCancel(){
      this.JLshow = false;
      this.MainId = "";
      this.tableDataJL = [];
    },

    async JLConfirm(){
      // let param = {};
      //
      // Api.memberAccountWriteOff(param).then((res) => {
      //   ElMessage({
      //     message: res.data.message || "操作成功",
      //     type: res.data.status,
      //   });
      //   this.JLCancel();
      //   this.getData();
      // });
    },

    async onChunaReApproverApplyStatement(data){
      console.log("data", data);
      ElMessageBox.confirm("确认对该数据进行 反核销 操作？", "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Api
            .financeInUnWriteOff({
              recordId: data.recordId,
            })
            .then((res) => {
              ElMessage({
                message: res.data.message,
                type: res.data.status,
              });

              this.getFinanceInWriteoffRecorList(this.MainId);
            });
      });
    },

    getFinanceInWriteoffRecorList(id){
      Api
          .getWaybillFeeBillWriteoffRecorList({
            financeId: id,
          })
          .then((res) => {
            if (res.status == 200) {
              const data = res.data;
              if (data.status == "success") {
                let result = data.result;
                const datas = result;
                if (utils.jyCheckObjectType(datas) == "Array") {
                  this.writeOffRecordTable = datas;
                }
              }
            }
          });
    },

    async onGetWaybillFeeBillWriteoffRecorList(){
      this.MainId = this.currentItemArr[0]["financeId"];
      this.writeOffRecordTable = [];
      if (this.currentItemArr.length == 1) {
        Api
            .getWaybillFeeBillWriteoffRecorList({
              financeId: this.currentItemArr[0]["financeId"],
            })
            .then((res) => {
              if (res.status == 200) {
                const data = res.data;
                if (data.status == "success") {
                  let result = data.result;
                  const datas = result;
                  if (utils.jyCheckObjectType(datas) == "Array") {
                    this.writeOffRecordTable = datas;
                  }
                }
              }
            });
        this.writeoffRecorListVisible = true;
      } else {
        ElMessage({
          message: "请选择表格数据",
          type: "warning",
        });
      }
    },

    writeoffRecorListCancel(){
      this.writeoffRecorListVisible = false;
      this.getData();
    },


    onViewAnnexD(row){
      this.annexTableBF = [];
      const item = row.row;
      if (item.number) {
        Api.getFileList({
          documentStatus: "finance_writeoff_record_v3:document_status" ,
          documentNumber:item.number
        }).then((res) => {
          let filse = res.data.result || {};
          if (filse) {
            this.writeoffRecorFJVisible = true;
            this.annexTableBF = filse;
          } else {
            ElMessage({
              message: "打开失败,没有检测到图片地址",
              type: "error",
            });
          }
        });
      } else {
        ElMessage({
          message: "没发现附件哦！",
          type: "error",
        });
      }
    },


    writeoffRecorFJCancel(){
      this.writeoffRecorFJVisible = false;
    },

    async onCreateStatement(){
      if (this.currentItemArr.length >= 1) {
        let currency = this.currentItemArr[0].currency;
        let currencyId = this.currentItemArr[0].currencyId;
        let objectStatus = this.currentItemArr[0].objectStatus;
        let objectStatusConfDictId = this.currentItemArr[0].objectStatusConfDictId;
        let objectNumber = this.currentItemArr[0].objectNumber;
        let objectName = this.currentItemArr[0].objectName;
        for (let key in this.currentItemArr) {
          let ele = this.currentItemArr[key];
          if (!ele.currency) {
            ElMessage({
              message: "请设置币种！",
              type: "error",
            });
            return false;
          }
          if (ele.currency !== currency) {
            ElMessage({
              message: "所选数据币种不一致！",
              type: "error",
            });
            return false;
          }
          if (ele.objectStatus !== objectStatus) {
            ElMessage({
              message: "所选数据结算对象类型不一致！",
              type: "error",
            });
            return false;
          }
          if (ele.objectStatusConfDictId !== objectStatusConfDictId) {
            ElMessage({
              message: "所选数据结算对象类型不一致！",
              type: "error",
            });
            return false;
          }
          if (ele.objectNumber !== objectNumber) {
            ElMessage({
              message: "所选数据结算对象不一致！",
              type: "error",
            });
            return false;
          }
          if (ele.objectName !== objectName) {
            ElMessage({
              message: "所选数据结算对象不一致！",
              type: "error",
            });
            return false;
          }

        }
        sessionStorage.setItem(
            "ysTableStorageSelectData",
            JSON.stringify(this.currentItemArr)
        );
        let obj = {
          status: "create",
          currency: currency,
          currencyId: currencyId,
          objectStatus: objectStatus,
          objectStatusConfDictId: objectStatusConfDictId,
          financeType: "finance_record_group",
          objectName: objectName,
          memberId: objectNumber,
        };
        sessionStorage.setItem("clearReceivableManagementCenerateStatement", 1);
        await this.$router.push({
          path: "/pages/v4/finance/cenerateStatement",
          query: obj,
        });
      } else {
        ElMessage({
          message: "请选择表格数据",
          type: "warning",
        });
      }
    },










































  },




};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}

.classA {
  display: flex;
}

.glo_dialogForm .diaForm .dialogFormItems {
  height: 30px !important;
  line-height: 30px !important;
  overflow: hidden;
}

.couponBox {
  width: 100%;
  margin-bottom: 20px;
  height: 34px;

  .couponitmeInput {
    width: 100px;
    border: 1px solid #cccccc;
    margin: 0 6px;

    ::v-deep .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }

  .couponItemA {
    display: flex;
    align-items: center;
  }
}

.displays {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.rows {
  display: flex;
  width: 100%;
}

.multipleSelect {
  ::v-deep .el-select {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}
</style>
  